import type { LocalDatabaseCustomerGroup } from "../../../_Generated/Sync.gen";
import type { BaseCustomerGroupRepository } from "../../_Bases/BaseCustomerGroupRepository";
import type { InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBCustomerGroupRepository extends BaseIndexedDBRepository<
    LocalDatabaseCustomerGroup
> implements BaseCustomerGroupRepository {
    public readonly source: InternalIndexedDBDatabase["customerGroups"];
    protected readonly dataTypeName = "Customer Group";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.customerGroups;
    }

    public search(value: string): Promise<Array<LocalDatabaseCustomerGroup>> {
        const needle = value.trim().toLowerCase();

        if(!needle) {
            return this.all();
        }

        return this.source
            .filter(customerGroup => {
                return customerGroup.name.toLowerCase().includes(needle);
            })
            .toArray();
    }
}
